import SlideUp from '@/common/utils/slideUp';
import { LogoSvg } from '@/common/svgs';
import FadeIn from '@/common/utils/fadeIn';
import parse from 'html-react-parser';
import { Qrcode } from '@/typings/types';

type TitleProps = {
  header: Qrcode['header'];
};
const Title = ({ header }: TitleProps) => {
  return (
    <div className={'w-full flex flex-col items-center justify-center'}>
      <div className={'flex flex-col relative z-20 items-center justify-center'}>
        <SlideUp
          yOffset={20}
          delay
          delayDuration={550}
          className={
            'mb-14 hidden w-full max-w-[405px] sm:w-[405px] lg:block 3xl:w-7/12 3xl:max-w-7xl'
          }
        >
          <LogoSvg />
        </SlideUp>
        <FadeIn className={'my-14 block w-full max-w-[320px] sm:w-[405px] lg:hidden'}>
          <LogoSvg />
        </FadeIn>
        <SlideUp delay delayDuration={200} yOffset={50} className={'relative w-10/12 lg:w-7/12'}>
          {header?.text && (
            <h1 className={'text-2xl lg:text-3xl text-center font-libertineRegular'}>
              {parse(header.text)}
            </h1>
          )}
        </SlideUp>
      </div>
    </div>
  );
};

export default Title;
